
<template>
  <modal
    name="qotd-modal"
    :adaptive="true"
    :classes="['v--modal', 'qotd-modal']"
    height="auto"
    :max-width="370"
    @before-open="beforeOpen"
  >
    <div class="modal-content">
      <img
        :src="imageUrl"
        role="presentation"
        alt=""
      />
      <p class="title">
        {{ title }}
      </p>
      <p class="text">
        {{ text }}
      </p>
      <mastery-button
        :variant="'green'"
        @mastery-button-clicked="keepGoing()"
      >
        {{ buttonPositiveText }}
      </mastery-button>
      <button
        class="cancel-button"
        @click="finished"
      >
        {{ buttonNegativeText }}
      </button>
    </div>
  </modal>
</template>

<script>
import MasteryButton from '@components/ui/masteryButton';

export default {
  components: { MasteryButton },
  data() {
    return {
      correct: null,
      currentConfig: null,
      keepGoingRoute: { name: 'home', categoryId: null },
      finishedRoute: { name: 'home', categoryId: null },
      defaultConfig: {
        correct: {
          attachment_id: 7318,
          header_text: 'Start a Hot Streak?',
          sub_text: 'Should we make it two in a row? Heck, maybe you\'ll hit ten. But first, let\'s shoot for two.',
          button_positive: 'KEEP GOING',
          button_negative: 'Not Right Now',
        },
        incorrect: {
          attachment_id: 7318,
          header_text: 'Can\'t Win \'Em All',
          sub_text: 'But you could win this next one. Maybe even end up on a hot streak and get three in a row. Wanna try?',
          button_positive: 'KEEP GOING',
          button_negative: 'Not Right Now',
        },
      },
    };
  },
  computed: {
    config() {
      const config = this.$store.getters['productVars/get']['qotd_modal_config']?.parsedValue;
      return config;
    },
    imageUrl() {
      if (this.currentConfig) {
        const attachmentId = this.currentConfig['attachment_id'];
        const attachment = this.$store.getters['attachments/get'][attachmentId];
        return attachment?.url;
      }
    },
    title() {
      if (this.currentConfig) {
        return this.currentConfig['header_text'];
      }
    },
    text() {
      if (this.currentConfig) {
        return this.currentConfig['sub_text'];
      }
    },
    buttonPositiveText() {
      if (this.currentConfig) {
        return this.currentConfig['button_positive'];
      }
    },
    buttonNegativeText() {
      if (this.currentConfig) {
        return this.currentConfig['button_negative'];
      }
    },
    analyticsParams() {
      return { correct: this.correct };
    },
  },
  methods: {
    beforeOpen(event) {
      this.correct = event?.params?.correct;
      if (this.correct === null) {
        this.currentConfig = this.defaultConfig;
      } else {
        this.currentConfig = this.correct ? this.defaultConfig['correct'] : this.defaultConfig['incorrect'];
      }
      this.keepGoingRoute = event.params['keepGoingRoute'] || this.keepGoingRoute;
      this.finishedRoute = event.params['finishedRoute'] || this.finishedRoute;
      this.$analytics.events.qotdViewedModal(this.analyticsParams);
    },
    finished() {
      this.$modal.hide('qotd-modal');
      this.$router.push(this.finishedRoute);
      this.$analytics.events.qotdDismissedModal(this.analyticsParams);
    },
    keepGoing() {
      this.$modal.hide('qotd-modal');
      this.$router.push(this.keepGoingRoute);
      this.$analytics.events.qotdContinued(this.analyticsParams);
    },
  },
};
</script>

<style lang="scss">
.v--modal-overlay[data-modal="qotd-modal"] {
  background: rgba(0, 0, 0, .90);

  .v--modal {
    background: white;
    border-radius: 4px;
    box-shadow: none;
    padding: rem-calc(28);
  }
}

.qotd-modal {
  $success-green: #00b46d;
  display: flex;
  align-items: center;
  justify-content: center;

  .modal-content {
    max-width: rem-calc(376);
    text-align: center;
    line-height: 1.5;

    .title {
      font-size: rem-calc(26);
      font-weight: $bold;
      line-height: 1.23;
      margin-bottom: 0;
    }

    .text {
      margin-top: rem-calc(4);
    }

    img {
      max-width: 75%;
    }

    .cancel-button {
      background: transparent;
      display: block;
      font-size: rem-calc(11);
      margin: rem-calc(24) auto 0 auto;

      &:hover {
        text-decoration: underline;
      }
    }
  }

}
</style>
